export default {
    0: 'Amateur',
    1: 'Intermédiaire',
    2: 'Confirmé',
}
